// extracted by mini-css-extract-plugin
module.exports = {"adminMenuWrapper":"AdminMenu_adminMenuWrapper__2n8H_","adminMenuHolder":"AdminMenu_adminMenuHolder__kfNUZ"};